/**
*	@name							Accordion
*	@descripton						This Jquery plugin makes creating accordions pain free
*	@version						1.3
*	@requires						Jquery 1.2.6+
*
*	@author							Jan Jarfalk
*	@author-email					jan.jarfalk@unwrongest.com
*	@author-website					http://www.unwrongest.com
*
*	@licens							MIT License - http://www.opensource.org/licenses/mit-license.php
*/

(function(jQuery){
     jQuery.fn.extend({  
         accordion: function() {       
            return this.each(function() {
            	
            	var $ul = $(this);
            	
				if($ul.data('accordiated'))
					return false;

				$ul.data('accordiated', true);
													
				$.each($ul.children('li').children('div'), function(){
					$(this).data('accordiated', true);
					if (!$(this).parent('li').hasClass('active')) {
						$(this).hide();
					}
				});
				
				$.each($ul.children('li').children('a'), function(){
					$(this).click(function(e){
						activate(this);
						return void(0);
					});
				});
				
				var active = '';
				if (location.hash) {
					try {
						active = $ul.children('li').children('a[href="' + location.hash + '"]')[0] || '';
					} catch (err) {
						active = '';
					}
				}

				if(active){
					activate(active, 'toggle');
					$(active).parents().show();
				}
				
				function activate(el,effect){
					var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
					var hideFn = reduceMotion ? 'hide' : 'slideUp';
					var toggleFn = effect || (reduceMotion ? 'toggle' : 'slideToggle');
					$(el).parent('li').toggleClass('active').siblings().removeClass('active').children('ul, div')[hideFn](reduceMotion ? 0 : 'fast');
					$(el).siblings('ul, div')[toggleFn]((!effect && !reduceMotion)?'fast':null);
				}
				
            });
        } 
    }); 
})(jQuery);
